var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lang_mode == 'de')?_c('DE'):(_vm.lang_mode == 'en')?_c('EN'):(_vm.lang_mode == 'es')?_c('ES'):(_vm.lang_mode == 'fr')?_c('FR'):(_vm.lang_mode == 'it')?_c('IT'):(_vm.lang_mode == 'ko')?_c('KO'):(_vm.lang_mode == 'zh')?_c('ZH'):(_vm.lang_mode == 'zh-TW')?_c('ZHTW'):_c('JP')
}
var staticRenderFns = []

export { render, staticRenderFns }